import { type ReactElement } from 'react';

import { Logo } from '@/components';
import { LandingLayout } from '@/layouts';

import { LandingCommentsAnimation } from '../../components/LandingComments/LandingComments';
import { LandingForgotPasswordForm } from '../../components/LandingForgotPasswordForm/LandingForgotPasswordForm';
import styles from './LandingForgotPassword.module.scss';

export function LandingForgotPassword(): ReactElement {
  return (
    <LandingLayout
      leftChild={<LandingCommentsAnimation />}
      rightChild={
        <div className={styles.container}>
          <Logo className={styles.logo} size={'large'} />
          <div className={styles.content}>
            <h1 className={styles.title}>Forgot Password</h1>
            <p className={styles.description}>
              Enter the email address you used when you joined and we&apos;ll
              send you a link to reset your password.
            </p>
            <LandingForgotPasswordForm />
          </div>
        </div>
      }
    />
  );
}
